import { Link, NavLink, useNavigate, useParams } from 'react-router-dom'
import { AuthData } from '../../auth/AuthWrapper'
import { useEffect, useReducer, useState } from 'react'
import Logo from '../../assets/img/circo_color_logo.png'
import useSession from 'react-session-hook'
import $ from 'jquery'
import urls from '../constants/apiurl'
import ApiCaller from '../constants/ApiCaller'
import { showDangerToast, showToast } from '../constants/toaster'
import { useDispatch } from 'react-redux'
import commonSlice, {
  updatePermission,
  updateUserData,
  uplodateLoading
} from '../../redux/features/common/commonSlice'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton } from '@mui/material'
export const ResetPassword = () => {
  const { token } = useParams()
  const dispatch = useDispatch()
  const session = useSession()
  const navigate = useNavigate()
  const { login } = AuthData()
  const [formData, setFormData] = useReducer(
    (formData, newItem) => {
      return { ...formData, ...newItem }
    },
    { userName: '', password: '' }
  )
  const [errorMessage, setErrorMessage] = useState(null)
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/
  useEffect(() => {
    $('body').addClass('bg-default')
  })
  const fetchPermissions = async (id, token) => {
    let path = urls.fetchPermission + '/' + id
    let res = await ApiCaller.get({}, path, token)
    const response = await res.response.json()
    if (response.status == 200) {
      dispatch(updatePermission(response.data))
    }
  }

  const handleMouseDownPassword = event => {
    event.preventDefault()
  }

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfrimPassword] = useState(false)

  const togglePassword = e => {
    e.preventDefault()
    setShowPassword(!showPassword)
  }
  const toggleConfirmPassword = e => {
    e.preventDefault()
    setShowConfrimPassword(!showConfirmPassword)
  }

  const doLogin = async () => {
    try {
      // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/;

      //  if(!passwordRegex.test(formData.password)){
      //   showToast("password should be in valid format ");
      //  }
      dispatch(uplodateLoading(true))
      let postJson = { token, newPassword: formData.password, confirmPassword: formData.confirmPassword }
      let path = urls.resetAdminPassword
      let res = await ApiCaller.post(postJson, path)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(uplodateLoading(false))
        showToast(response.message)
        navigate('/login')
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  useEffect(() => {
    console.log(token)
  }, [token])

  return (
    <>
      <div className='main-content'>
        <div className='header bg-gradient-primary py-7 py-lg-8'>
          <div className='container'>
            <div className='header-body text-center mb-7'>
              <div className='row justify-content-center'>
                <div className='col-lg-5 col-md-6'>
                  <h1 className='text-white'>Reset Password!</h1>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='separator separator-bottom separator-skew zindex-100'>
            <svg
              x={0}
              y={0}
              viewBox='0 0 2560 100'
              preserveAspectRatio='none'
              version='1.1'
              xmlns='http://www.w3.org/2000/svg'
            >
              <polygon
                className='fill-default'
                points='2560 0 2560 100 0 100'
              />
            </svg>
          </div> */}
        </div>
        <div className='container mt--8 pb-5'>
          <div className='row justify-content-center'>
            <div className='col-lg-5 col-md-7'>
              <div className='card bg-secondary shadow border-0'>
                <div className='card-body px-lg-5 py-lg-5'>
                  <div className='text-center text-muted mb-4'>
                    <img src={'https://praxo-dev.s3.ap-south-1.amazonaws.com/admin-resources/admin_Logo.png'} width={'50%'} />
                  </div>
                  <form role='form'>
                    <div className='form-group'>
                      <div className='input-group input-group-alternative'>
                        <div className='input-group-prepend'>
                          <span className='input-group-text'>
                            <i className='ni ni-lock-circle-open' />
                          </span>
                        </div>
                        <input
                          className='form-control'
                          placeholder='New Password'
                          value={formData.password}
                          onChange={e =>
                            setFormData({ password: e.target.value })
                          }
                          type={showPassword ? 'text' : 'password'}
                        />

                        <IconButton
                          style={{ marginRight: '1px' }}
                          aria-label='toggle password visibility'
                          onClick={togglePassword}
                          onMouseDown={handleMouseDownPassword}
                          edge='end'
                        >
                          {!showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </div>
                      {formData.password &&
                        !passwordRegex.test(formData.password) && (
                          <p className='custom-error-validation'>
                            Invalid Format
                          </p>
                        )}
                    </div>
                    <div className='form-group'>
                      <div className='input-group input-group-alternative'>
                        <div className='input-group-prepend'>
                          <span className='input-group-text'>
                            <i className='ni ni-lock-circle-open' />
                          </span>
                        </div>
                        <input
                          className='form-control'
                          placeholder='Confirm Password'
                          value={formData.confirmPassword}
                          onChange={e =>
                            setFormData({ confirmPassword: e.target.value })
                          }
                          type={showConfirmPassword ? 'text' : 'password'}
                        />

                        <IconButton
                          style={{ marginRight: '1px' }}
                          aria-label='toggle password visibility'
                          onClick={toggleConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge='end'
                        >
                          {!showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </div>
                      {formData.confirmPassword &&
                        !passwordRegex.test(formData.confirmPassword) && (
                          <p className='custom-error-validation'>
                            Invalid Format
                          </p>
                        )}
                      {formData.confirmPassword &&
                        formData?.password !== formData.confirmPassword && (
                          <p className='custom-error-validation'>
                            New Password and Confirm Password must be same.
                          </p>
                        )}
                    </div>
                    <div className='text-center'>
                      <button
                        type='button'
                        className='btn btn-primary my-4'
                        onClick={doLogin}
                      >
                        Submit
                      </button>
                    </div>
                    {errorMessage ? (
                      <div className='error'>{errorMessage}</div>
                    ) : null}
                    <div className='text-center'>
                      <NavLink
                        activeClassName='active'
                        style={{ color: '#172b4d !important' }}
                        to={'/login'}
                        className='nav-link'
                      >
                        <small>Back to Login ?</small>
                      </NavLink>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <footer className='py-5'>
          <div className='container'>
            <div className='row align-items-center justify-content-xl-between'>
              <div className='col-xl-6'>
                <div className='copyright text-center text-xl-left text-muted'>
                  © 2018{' '}
                  <a
                    href='https://www.creative-tim.com'
                    className='font-weight-bold ml-1'
                    target='_blank'
                  >
                    Creative Tim
                  </a>
                </div>
              </div>
              <div className='col-xl-6'>
                <ul className='nav nav-footer justify-content-center justify-content-xl-end'>
                  <li className='nav-item'>
                    <a
                      href='https://www.creative-tim.com'
                      className='nav-link'
                      target='_blank'
                    >
                      Creative Tim
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='https://www.creative-tim.com/presentation'
                      className='nav-link'
                      target='_blank'
                    >
                      About Us
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='http://blog.creative-tim.com'
                      className='nav-link'
                      target='_blank'
                    >
                      Blog
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md'
                      className='nav-link'
                      target='_blank'
                    >
                      MIT License
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer> */}
      </div>
    </>
  )
}
